import { useEffect, useRef, useState } from 'react'
import AMapLoader from '@amap/amap-jsapi-loader'
import { Toast } from '@ow/comps'
import locationImg from './assets/location.png'

const defaultCenter = [116.83379593647048, 39.61736734567014]

const useAmap = (containerSlug) => {
  const [AMap, setAMap] = useState(null)
  const [amap, setAmap] = useState(null)
  const locationMarkerRef = useRef(null)

  // 初始化地图
  const init = (theme) => {
    AMapLoader.load({
      key: '0e4f7b5e424e7db93755cb5d48e71a75',
      version: '2.0',
      plugins: ['AMap.Geocoder'],
      Loca: {
        version: '2.0.0',
      },
    }).then((Amap) => {
      const _amap = new Amap.Map(containerSlug, {
        center: defaultCenter,
        zoom: 14,
        mapStyle: `amap://styles/${theme}`,
      })
      setAMap(Amap)
      setAmap(_amap)
    })
  }

  const icon = () => {
    return new AMap.Icon({
      size: new AMap.Size(24, 33),
      image: locationImg,
      imageSize: new AMap.Size(24, 33),
    })
  }

  const setCenter = (c) => {
    amap.setCenter(c)
  }

  // 根据坐标获取地点信息
  const regeoCode = (lnglat, city, getAddress) => {
    const geocoder = new AMap.Geocoder({
      city,
      radius: 1000,
    })
    geocoder.getAddress(lnglat, (status, result) => {
      if (status === 'complete' && result.regeocode) {
        getAddress(result.regeocode.formattedAddress)
      }
    })
  }

  // 添加点
  const addMarker = (lnglat, map, getMarkerInfo) => {
    const options = {
      icon: new AMap.Icon({
        size: new AMap.Size(24, 33),
        image: locationImg,
        imageSize: new AMap.Size(24, 33),
      }),
      position: lnglat,
      draggable: true,
    }

    const marker = new AMap.Marker(options)
    marker.on('dragend', (v) => {
      getMarkerInfo(v, true)
    })

    map.add(marker)

    getMarkerInfo(marker.getPosition())

    return marker
  }

  // 给地图添加定位事件,获取定位信息
  const addPositionEvent = (draggeLocation) => {
    amap.plugin('AMap.Geolocation', () => {
      const geolocation = new AMap.Geolocation({
        enableHighAccuracy: true,
        timeout: 10000,
        maximumAge: 0,
        // convert: true,
        showButton: true,
        buttonPosition: 'LB',
        buttonOffset: new AMap.Pixel(10, 20),
        showMarker: false,
        showCircle: true,
        panToLocation: true,
        zoomToAccuracy: true,
        getCityWhenFail: true,
        // noGeoLocation: 3,
      })
      amap.addControl(geolocation)
      geolocation.getCurrentPosition({})

      AMap.Event.addListener(geolocation, 'complete', (v) => {
        const { position } = v
        let lnglat
        if (Array.isArray(position)) {
          lnglat = position
        } else {
          const { lng, lat } = position
          lnglat = [lng, lat]
        }
        if (locationMarkerRef.current) {
          amap.remove(locationMarkerRef.current)
        }
        locationMarkerRef.current = addMarker(lnglat, amap, draggeLocation)
      })
      AMap.Event.addListener(geolocation, 'error', (v) => {
        console.log('定位失败', v)
        Toast.error({
          title: '定位失败！',
          description: v.message,
        })
      })
    })
  }

  useEffect(() => {
    return () => {
      if (amap) {
        amap.destroy()
      }
    }
  }, [amap])

  return {
    init,
    amap,
    AMap,
    icon,
    setCenter,
    addMarker,
    regeoCode,
    addPositionEvent,
  }
}
export default useAmap
